/*
Author : Abaid
Module: Department
github: https://github.com/abaid
*/
import { createSlice } from '@reduxjs/toolkit';

import { ResponseApi } from '../BaseApi';
import {NotifyHost} from "./InvitationApi";

const InvitationSlice = createSlice({
    name: 'invitation',
    initialState: {
        getAllInvitation: [],
        createInvitation: {},
        updateInvitation: {},
        deleteInvitation: {},
        getInvitationById: null,
        getSearchUserService: {},
        countAllByAllStatus: [],
        updateVisitorStatus: null,
        notifyHost:{},
        publicGetQrCodeByUserId: null

    },
    reducers: {
        searchUserService(state) {
            state.getSearchUserService = {};
        },
    },
    extraReducers: {
        'invitation/getAllInvitation/fulfilled': (state, action) => {
            state.getAllInvitation = ResponseApi(action.payload);
        },
        'invitation/getSearchUserService/fulfilled': (state, action) => {
            state.getSearchUserService = ResponseApi(action.payload);
        },
        'invitation/createInvitation/fulfilled': (state, action) => {
            state.createInvitation = ResponseApi(action.payload);
        },
        'invitation/updateInvitation/fulfilled': (state, action) => {
            state.updateInvitation = ResponseApi(action.payload);
        },
        'invitation/deleteInvitation/fulfilled': (state, action) => {
            state.deleteInvitation = ResponseApi(action.payload);
        },
        'invitation/getInvitationById/fulfilled': (state, action) => {
            state.getInvitationById = ResponseApi(action.payload) || {};
        },
        'invitation/countAllByAllStatus/fulfilled': (state, action) => {
            state.countAllByAllStatus = ResponseApi(action.payload);
        },
        'invitation/publicUpdateVisitorStatusByInvitationId/fulfilled': (state, action) => {
            state.updateVisitorStatus = ResponseApi(action.payload);
        },
        'invitation/notifyHost/fulfilled': (state, action) => {
            state.notifyHost = ResponseApi(action.payload);
        },
        'invitation/publicGetQrCodeByUserId/fulfilled': (state, action) => {
            state.publicGetQrCodeByUserId = ResponseApi(action.payload);
        },
    },
});

export const { searchUserService } = InvitationSlice.actions;

export default InvitationSlice.reducer;
